/*!
 * Copyright (C) 2019, Peppermill Inc.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are not permitted.
 *//*
 *	2019-05-20
 *		- Peppermill Preferred code moved from lazy.js.
 *
 *	2022-06-27
 *		- Fix Preferred login/enroll default callbacks to send guests to /resort/.
 */

(function ($, window, document) {
	
	var $preferredLogin					=	null;
	var preferredLoginCallbackSuccess	=	null;
	var preferredLoginCallbackError		=	null;
	var preferredLoginLoading			=	false;
	var preferredDevMode				=	!/^(reserve2\.peppermillcas\.com)|(www\.peppermillreno\.com)$/.test(location.hostname);
	var preferredWebAPIHost				=	(preferredDevMode)
												?	'https://dev.peppermillreno.com'
												:	'https://www.peppermillreno.com';
	var preferredAPIURI					=	(preferredDevMode)
												?	'https://reserve1.peppermillcas.com:4323/resnet-api/?TEST=YES'
												:	'https://reserve1.peppermillcas.com:4323/resnet-api/';
	window.peppermillPreferred			=	{};
	
	function setCachedData (storageKey, data) {

		if (typeof storageKey !== 'string')	return false;
		if (typeof data == 'undefined')		return false;
		
		if ('JSON' in window) {
			
			if (Modernizr.localstorage) {
				
				return localStorage.setItem(storageKey, JSON.stringify({
					TIMESTAMP	:	new Date().getTime(),
					DATA		:	data
				}));
				
			} else {
				
				var cookieData	=	$('html').data('cookie');
				
				if (cookieData) {
					
					document.cookie = storageKey + '=' + JSON.stringify({ TIMESTAMP : new Date().getTime(), DATA : data }) + '; path=' + cookieData.b + '; ' + cookieData.s + '; ' + cookieData.h;
					
				}
				
			}
			
		}
		
		return false;
		
	}
	
	function getCachedData (storageKey, storageTTL) {
		
		if (typeof storageKey !== 'string')	return false;
		if (typeof storageTTL !== 'number')	var storageTTL	=	3600000;	//default to 1 hour
		
		var dataSTR	=	'';
		var dataOBJ	=	{};
		
		try {
			
			if ('JSON' in window) {
				
				if (Modernizr.localstorage) {
					
					dataSTR	=	localStorage.getItem(storageKey);
					
					if (dataSTR) {
						
						dataOBJ	=	JSON.parse(dataSTR);
						
						if (dataOBJ.TIMESTAMP + storageTTL > new Date().getTime()) {
							
							return dataOBJ;
							
						} else {
							
							localStorage.removeItem(storageKey);
							
						}
						
					}
					
				} else {
					
					//look for cookie
					var regex	=	new RegExp('(?:(?:^|.*;\\s*)' + storageKey + '\\s*\\=\\s*([^;]*).*$)|^.*$');
					dataSTR	=	document.cookie.replace(regex, "$1");
					
					if (dataSTR) {
						
						dataOBJ	=	JSON.parse(dataSTR);
						
						if (dataOBJ.TIMESTAMP + storageTTL > new Date().getTime()) {
							
							return dataOBJ;
							
						} else {
							
							var cookieData	=	$('html').data('cookie');
							var expireDate	=	new Date();
							
							expiresDate.setTime(new Date().getTime() + 900000);
							
							if (cookieData) {
								
								document.cookie = storageKey + '=; expires=' + (expireDate.toGMTString()) + '; path=' + cookieData.b + '; ' + cookieData.s + '; ' + cookieData.h;
								
							}
							
						}
						
					}
					
				}
				
			}
			
		} catch (e) {
			
			console.log(e);
			
		}
		
		return false;
		
	}
	
	function removeCachedData (storageKey) {
		
		if (typeof storageKey !== 'string')	return false;
		
		try {
			
			if (Modernizr.localstorage) {
				
				return localStorage.removeItem(storageKey);
				
			} else {
				
				var cookieData	=	$('html').data('cookie');
				var expireDate	=	new Date();
				
				expiresDate.setTime(new Date().getTime() - 900000);
				
				if (cookieData) {
					
					document.cookie = storageKey + '=; expires=' + (expireDate.toGMTString()) + '; path=' + cookieData.b + '; ' + cookieData.s + '; ' + cookieData.h;
					
					return true;
					
				}
				
			}
			
		} catch (e) {
			
			console.log(e);
			
		}
		
		return false;
		
	}
	
	peppermillPreferred.showLoginForm	=	function (callbackSuccess, callbackError) {
		
		$('html')
			.addClass('show-overlay');
		
		if (typeof callbackSuccess === 'function')	preferredLoginCallbackSuccess	=	callbackSuccess;
		else										preferredLoginCallbackSuccess	=	null;
		
		if (typeof callbackError === 'function')	preferredLoginCallbackError		=	callbackError;
		else										preferredLoginCallbackError		=	null;
		
		if (null === $preferredLogin) {
			
			//need to grab the HTML for the login form
			
			if (preferredLoginLoading)	return;
			
			preferredLoginLoading	=	true;
			
			$('html')
				.addClass('show-loading-spinner');
			
			$.ajax({
				url			:	preferredWebAPIHost + '/library/api/resnet.php',
				dataType	:	'JSON',
				data		:	{
					ACTION	:	'SHOW_PREFERRED_DIALOG'
				},
				success		:	function (response) {
					
					if (response.STATUS === 'SUCCESS') {
						
						$preferredLogin	=	$(response.HTML);
						
						$('body')
							.append($preferredLogin);
						
						$preferredLogin
							.on('close', function () {
								
								var $dialog	=	$(this);
								
								$dialog
									.removeClass('active');
								
								$('html')
									.removeClass('show-overlay');
								
								setTimeout(function () {
									
									$dialog
										.children()
											.removeClass('active')
										.end()
										.children('.onboard')
											.addClass('active');
									
									$dialog
										.find('.actions')
											.find('a')
												.removeClass('hide');
									
								}, 500);
								
							})
							.on('click', function (event) {
								
								event.stopPropagation();
								
							})
							.find('.pepvalidate-v3')
								.filter('.sign-in-preferred')
									.attr('action', preferredAPIURI)
								.end()
								.each(window.pepvalidateInitForm)
							.end()
							.find('.close')
								.on('click', function (event) {
									
									event.preventDefault();
									
									$(this)
										.closest('.dialog')
											.trigger('close');
									
								})
							.end()
							.find('.sign-up-now')
								.on('click', function (event) {
	
									event.preventDefault();
									event.stopPropagation();
									
									$preferredLogin
										.children()
											.removeClass('active')
										.end()
										.children('.signup')
											.addClass('active');
									
									$preferredLogin
										.find('.actions')
											.find('a')
												.removeClass('hide')
												.filter('.sign-up-now')
													.addClass('hide');
									
								})
							.end()
							.find('.login-now')
								.on('click', function (event) {
	
									event.preventDefault();
									event.stopPropagation();
									
									$preferredLogin
										.children()
											.removeClass('active')
										.end()
										.children('.onboard')
											.addClass('active');
									
									$preferredLogin
										.find('.actions')
											.find('a')
												.removeClass('hide')
												.filter('.login-now-mobile')
													.addClass('hide');
									
								})
							.end()
							.find('.login-now-mobile')
								.on('click', function (event) {
		
									event.preventDefault();
									event.stopPropagation();
									
									$preferredLogin
										.children()
											.removeClass('active')
										.end()
										.children('.login')
											.addClass('active');
									
									$preferredLogin
										.find('.actions')
											.find('a')
												.removeClass('hide')
												.filter('.login-now-mobile')
													.addClass('hide');
									
								})
							.end()
							.find('.step.login')
								.find('.pepvalidate-v3')
									.on('click', function (event) {
										
										$(this)
											.addClass('active')
											.siblings('.pepvalidate-v3')
												.removeClass('active');
										
									})
								.end()
							.end()
							.find('input.password-strength')
								.data({
									timer			:	null,
									lastValChecked	:	''
								})
								.on('change keyup paste', function (event) {
									
									var $input	=	$(this);
									
									clearTimeout($input.data('timer'));
									
									$input.data('timer', setTimeout(function () {
										
										if ($input.data('lastValChecked') === $input.val())	return;
										
										$input.data('lastValChecked', $input.val());
										
										var otherData	=	[];
										
										if ($input.closest('form').find('input[name=EMAIL]').val())			otherData.push($input.closest('form').find('input[name=EMAIL]').val());
										if ($input.closest('form').find('input[name=FIRST_NAME]').val())	otherData.push($input.closest('form').find('input[name=FIRST_NAME]').val());
										if ($input.closest('form').find('input[name=LAST_NAME]').val())		otherData.push($input.closest('form').find('input[name=LAST_NAME]').val());
										
										$.ajax({
											url			:	preferredWebAPIHost + '/library/api/resnet.php',
											type		:	'get',
											dataType	:	'json',
											data		:	{
												ACTION		:	'CHECK_PASSWORD_STRENGTH',
												PASSWORD	:	$input.val(),
												OTHER_DATA	:	otherData
											},
											success		:	function (response) {
												
												if (response.STATUS === 'SUCCESS' && 'SCORE' in response.DATA) {
													
													$input
														.siblings('.note')
															.removeClass('score-0 score-1 score-2 score-3 score-4')
																.addClass('score-' + parseInt(response.DATA.SCORE, 10));
													
												}
												
											},
											error		:	function (jqXHR, textStatus, errorThrown) {
												
												//log this error
												var extraText	=	(typeof errorThrown === 'string')
																		?	' -- ' + errorThrown
																		:	'';
												//pepTracking.event('JS Error', 'Peppermill Preferred Check Pasword Strength', textStatus + extraText, 0, true);
												
												if ('reportError' in window)	reportError('Peppermill Preferred Check Pasword Strength', 'preferred-club.js', 0, 0, jqXHR);
												
											}
										});
										
									}, 500));
									
								});
						
						$(document)
							.on('click', function () {
								
								$preferredLogin
									.removeClass('active');
								
							});
						
						setTimeout(function () {
							
							preferredLoginLoading	=	false;
							
							activatePreferredLoginForm();
							
						}, 33);
						
					}
					
				},
				error		:	function (jqXHR, textStatus, errorThrown) {
					
					//log this error
					var extraText	=	(typeof errorThrown === 'string')
											?	' -- ' + errorThrown
											:	'';
					//pepTracking.event('JS Error', 'Peppermill Preferred Login Setup', textStatus + extraText, 0, true);
					
					if ('reportError' in window)	reportError('Peppermill Preferred Login Setup', 'preferred-club.js', 0, 0, jqXHR);
					
				},
				complete	:	function () {
					
					$('html')
						.removeClass('show-loading-spinner');
					
				}
			});
			
		} else {
			
			//form HTML has already been grabbed
			activatePreferredLoginForm();
			
		}
		
	};
	
	function activatePreferredLoginForm () {
		
		$preferredLogin
			.addClass('active');
		
	}
	
	peppermillPreferred.getPeppermillPreferredClientID	=	function (token, callbackSuccess, callbackError) {
		
		//console.log('getPeppermillPreferredClientID', token, typeof token === 'string', typeof callbackSuccess === 'function', typeof callbackError === 'function');
		
		if (typeof token === 'string' && typeof callbackSuccess === 'function' && typeof callbackError === 'function') {
			
			$.ajax({
				url			:	preferredAPIURI,
				type		:	'post',
				dataType	:	'json',
				data		:	{
					ACTION	:	'PEPPERMILL_PREFERRED_GET_CLIENT_ID',
					TOKEN	:	token
				},
				success		:	function (response) {
					
					if (response.STATUS === 'SUCCESS' && 'CLIENT_CODE' in response.DATA) {
						
						callbackSuccess.call(window, response.DATA.CLIENT_CODE);
						
					} else {

						//call the error callback, second parameter is for "hard error"
						callbackError.call(window, false, response.MSG);
						
					}
					
				},
				error		:	function (jqXHR, textStatus, errorThrown) {
					
					//call the error callback, second parameter is for "hard error"
					callbackError.call(window, true);
					
					//log this error
					var extraText	=	(typeof errorThrown === 'string')
											?	' -- ' + errorThrown
											:	'';
					//pepTracking.event('JS Error', 'Peppermill Preferred Get Client ID', textStatus + extraText, 0, true);
					
					if ('reportError' in window)	reportError('Peppermill Preferred Get Client ID', 'preferred-club.js', 0, 0, jqXHR);
					
				}
			});
			
		}
		
	}
	
	peppermillPreferred.verifyPeppermillPreferredLogin	=	function (callbackSuccess, callbackError) {
		
		var tokenData	=	peppermillPreferred.getPeppermillPreferredLoginData();
		var token		=	'';
		
		if ('DATA' in tokenData && 'TOKEN' in tokenData.DATA)	token	=	tokenData.DATA.TOKEN;
		
		if (typeof token === 'string' && typeof callbackSuccess === 'function' && typeof callbackError === 'function') {
			
			//just run the function to get a client ID
			peppermillPreferred.getPeppermillPreferredClientID(token, callbackSuccess, callbackError);
			
		} else {
			
			//call the error callback, second parameter is for "hard error"
			callbackError.call(window, false, 'Invalid parameters.');
			
		}
		
	}
	
	peppermillPreferred.getPeppermillPreferredLoginData	=	function () {
		
		var tokenData	=	getCachedData('PEPPERMILL-PREFERRED-LOGIN-TOKEN', 63072000000);	//2 years... we'll check the server-set expiration later
		
		if (typeof tokenData === 'object' && 'DATA' in tokenData && 'TOKEN' in tokenData.DATA && 'EXPIRATION' in tokenData.DATA) {
			
			return tokenData;
			
		}
		
		return false;
		
	}
	
	peppermillPreferred.checkForPeppermillPreferredLoginToken	=	function () {
		
		var tokenData;
		var expireDate;
		var currentDate;
		var output	=	false;
		
		try {
			
			tokenData	=	peppermillPreferred.getPeppermillPreferredLoginData();
			
			if (tokenData && 'DATA' in tokenData && 'EXPIRATION' in tokenData.DATA && 'TOKEN' in tokenData.DATA) {
				
				//let's check that the expiration hasn't come and gone
				expireDate	=	new Date(tokenData.DATA.EXPIRATION);
				currentDate	=	new Date();
				
				if (expireDate.getTime() < currentDate.getTime()) {
					
					//too old...
					removeCachedData('PEPPERMILL-PREFERRED-LOGIN-TOKEN');
					
				} else {
					
					//everything looks good
					output	=	true;
					
				}
				
			}
			
		} catch (e) {
			
			console.log(e);
			
		}
		
		return output;
		
	}
	
	$(function () {
		
		function peppermillPreferredPepvalidateResponseErrorHandler (msg, eleName) {
			
			console.log('peppermillPreferredPepvalidateResponseErrorHandler()', msg, eleName, this);
			
			$(this)
				.removeClass('loading')
				.find('.submit-wrapper')
					.stop(true, true)
					.show();
			
			if (typeof eleName === 'string') {
				
				$(this)
					.find('[name="' + eleName + '"]')
						.focus();
				
			}
			
			if (typeof msg === 'string' && msg.length) {
				
				pepNotify.show(15000, msg);
				
			}
			
		}
		
		if ('pepvalidateRegisterCallback' in window) {
			
			window.pepvalidateRegisterCallback(
				'PEPPERMILL-PREFERRED-SIGNUP-SUCCESS',
				function (msg, loginToken, loginTokenExpiration) {
					
					var dialogCallback	=	'';
					
					//cache the login token
					setCachedData('PEPPERMILL-PREFERRED-LOGIN-TOKEN', {
						TOKEN		:	loginToken,
						EXPIRATION	:	loginTokenExpiration
					});
					
					if ($(this).data('preferred-callback')) {
						
						dialogCallback	=	$(this).data('preferred-callback');
						
					} else {
						
						dialogCallback	=	'PEPPERMILL-PREFERRED-CONTINUE-BOOKING-SIGNUP';
						
						ajaxLinkRegisterCallback(
							dialogCallback,
							function () {
								window.location = '/resort/?STR=1';
							}
						);
						
					}
					
					showOverlayDialog({
						alertMode		:	false,
						confirmAccept	:	'CONTINUE',
						confirmDeny		:	'CLOSE',
						confirmTitle	:	'You\'re All Signed Up!',
						confirmBody		:	msg,
						callback		:	dialogCallback
					});
					
				}
			);
			
			window.pepvalidateRegisterCallback(
				'PEPPERMILL-PREFERRED-LOGIN-SUCCESS',
				function (msg, loginToken, loginTokenExpiration) {
					
					var dialogCallback	=	'';
					
					//cache the login token
					setCachedData('PEPPERMILL-PREFERRED-LOGIN-TOKEN', {
						TOKEN		:	loginToken,
						EXPIRATION	:	loginTokenExpiration
					});
					
					if (typeof preferredLoginCallbackSuccess === 'function') {
						
						preferredLoginCallbackSuccess.apply(window, [ msg, loginToken, loginTokenExpiration ]);
						
					} else {
						
						if ($(this).data('preferred-callback')) {
							
							dialogCallback	=	$(this).data('preferred-callback');
							
						} else {

							dialogCallback = 'PEPPERMILL-PREFERRED-CONTINUE-BOOKING-LOGIN';
							ajaxLinkRegisterCallback(
								dialogCallback,
								function () {
									window.location = '/resort/?STR=1';
								}
							);
							
						}
						
						showOverlayDialog({
							confirmAccept	:	'CONTINUE',
							confirmDeny		:	'CLOSE',
							confirmTitle	:	'You\'re All Logged In!',
							confirmBody		:	msg,
							callback		:	dialogCallback
						});
						
					}
					
				}
			);
			
			window.pepvalidateRegisterCallback(
				'PEPPERMILL-PREFERRED-SIGNUP-ERROR',
				peppermillPreferredPepvalidateResponseErrorHandler
			);
			
			window.pepvalidateRegisterCallback(
				'PEPPERMILL-PREFERRED-LOGIN-ERROR',
				peppermillPreferredPepvalidateResponseErrorHandler
			);
			
			window.pepvalidateRegisterCallback(
				'PEPPERMILL-PREFERRED-RECOVERY-ERROR',
				peppermillPreferredPepvalidateResponseErrorHandler
			);
			
		}

		//FIND ON-BOARDING FORMS AND DISABLE IF ALREADY LOGGED IN
		var signupFormNodes = document.querySelectorAll('form.signup-preferred');
		if (signupFormNodes.length && peppermillPreferred.checkForPeppermillPreferredLoginToken()) {
			//user is logged in, let's check their token
			var tokenData = peppermillPreferred.getPeppermillPreferredLoginData();
			if (false !== tokenData) {
				//user has login data, let's validate it on the server
				peppermillPreferred.getPeppermillPreferredClientID(tokenData.DATA.TOKEN, function (clientCode) {
					signupFormNodes.forEach(function (formNode) {
						var bodyContainerNode = formNode.closest('.body-container');
						if (bodyContainerNode) {
							var viewportNode = bodyContainerNode.querySelector('.viewport');
							var titleNode = bodyContainerNode.querySelector('.tab-title');
							if (titleNode && viewportNode) {
								var newNode = document.createElement('p');
								newNode.innerHTML = 'You have already signed up and are logged in. To take advantage of your member rates see the "How It Works" section below!';
								titleNode.innerHTML = 'You are already logged in!';
								formNode.style.display = 'none';
								viewportNode.append(newNode);
							}
						}
					});
				}, function () {
					console.log('ERROR');
				});
			}
		}
		
	});
	
	
	
	
	//SETUP NOTIFICATIONS
	if (!('pepNotify' in window)) {
		
		if (!$('#notifications').length) {
			
			$('html')
				.append('<div id="notifications"><div class="viewport"></div></div>');
			
		}
		
		window.pepNotify	=	{
			ele			:	$('#notifications'),
			viewport	:	$('#notifications').children('.viewport'),
			show		:	function (duration, msg, type, actionText, actionLink, callback, forceClose) {
				
				if (typeof forceClose !== 'boolean')	var forceClose	=	false;
				
				//make sure this notification doesn't already exist
				var $match	=	pepNotify.viewport.children('.notification').filter(function () {
						
						var data	=	$(this).data();
						
						return (data.duration === duration && data.msg === msg && data.type === type && data.actionText === actionText && data.actionLink === actionLink);
						
					});
				
				if ($match.length) {
					
					if ($match.find('.count').length === 0) {
						
						$match.append('<span class="count">2</span>');
						
						setTimeout(function () {
							
							$match
								.find('.count')
									.onCSSAnimationEnd(function () {
										
										$(this).removeClass('bounce');
										
									})
									.addClass('show bounce');
							
						}, 50);
						
					} else {
						
						$match
							.find('.count')
								.text(parseInt($match.find('.count').text(), 10) + 1)
								.onCSSAnimationEnd(function () {
									
									$(this).removeClass('bounce');
									
								}).addClass('bounce');
						
					}
					
					pepNotify.reset($match);
					
					return;
					
				}
				
				var $ele	=	$(pepNotify.buildHTML(msg, type, actionText, actionLink, callback))
									.data({
										duration		:	duration,
										msg				:	msg,
										type			:	type,
										actionText		:	actionText,
										actionLink		:	actionLink,
										callback		:	callback,
										forceClose		:	forceClose
									});
				
				$ele
					.on('mouseenter', function () {
						
						if ($ele.hasClass('closing')) return;
						
						if (!$ele.data('forceClose'))	clearTimeout($ele.data('timer'));
						
						$ele.addClass('hover');
						
					})
					.on('mouseleave', function () {
						
						pepNotify.activate($ele);
						
						$ele.removeClass('hover');
						
					})
					.find('.action')
						.on('click', function (event) {
							
							if ($(this).hasClass('close') || $(this).attr('href') === '#')	event.preventDefault();
							
							$ele.removeClass('hover').addClass('closing');
							
							pepNotify.close($ele, true);
							
						});
				
				pepNotify.viewport.append($ele);
				
				if (pepNotify.viewport.children('.notification').filter('.active').length === 0) {
					
					setTimeout(function () {
						
						pepNotify.activate($ele);
						
					}, 50);
					
				}
				
			},
			close		:	function ($ele, closeFromClick) {
				if (typeof closeFromClick !== 'boolean') closeFromClick	=	false;
				
				pepNotify.ele.onCSSTransitionEnd(function () {
					if (!$ele.data('forceClose') && $ele.hasClass('hover') && !$ele.hasClass('closing'))	return;
					
					if (typeof $ele.data('callback') === 'function' && (closeFromClick || $ele.data('forceClose')))	{
						$ele.data('callback')();
					}
					
					$ele.remove();
					pepNotify.rotate();
				}).removeClass('show');
				
				$('html').removeClass('show-notify');
			},
			reset		:	function ($ele) {
				clearTimeout($ele.data('timer'));
				
				$ele.data('timer', setTimeout(function () {
					pepNotify.close($ele);
				}, $ele.data('duration')));
			},
			activate	:	function ($ele) {
				
				if ($ele.hasClass('closing'))	return;
				
				pepNotify.ele.addClass('show');
				
				$('html').addClass('show-notify');
				
				$ele.addClass('active').data('timer', setTimeout(function () {
					
					pepNotify.close($ele);
					
				}, $ele.data('duration')));
				
			},
			rotate		:	function () {
				
				var $notifications	=	pepNotify.viewport.children('.notification');
				
				if ($notifications.length > 0 && $notifications.filter('.active').length === 0) {
					
					pepNotify.activate($notifications.eq(0));
					
				}
				
			},
			buildHTML	:	function (msg, type, actionText, actionLink, actionCallback) {
				
				var html	=	'<div class="notification" role="status"><table class="no-zebra"><tbody><tr><td class="content">';
				
				if (typeof type === 'string')	html	+=	'<span class="material-icons">' + type + '</span> ';
				
				html	+=	msg + '</td><td class="action-cell">';
				
				if (typeof actionText === 'string' && (typeof actionLink === 'string' || typeof actionCallback === 'function'))	{
					
					if (typeof actionLink !== 'string')	var actionLink	=	'#';
					
					html	+=	'<a class="action" href="' + actionLink + '">' + actionText + '</span>';
					
				} else {
					
					html	+=	'<a class="action close" href="#">HIDE</span>';
					
				}
				
				html	+=	'</td></tr></table></div>';
				
				return html;
				
			}
		};
		
	}
	
	
	
	
	
	
	
	//if the user is alreay logged in, setup the UI
	var userLoggedIn	=	false;
	
	
})(jQuery, window, document);